export default {
  "5g.message.h5.login": "登录",
  "5g.message.h5.chatRoom.hismsg": "以上为历史消息",
  "5g.message.h5.chatRoom.send": "发送",
  "5g.message.h5.login.xieyi": "同意用户隐私政策",
  "5g.message.h5.login.modal.title": "用户注册及使用APP隐私协议",
  "5g.message.h5.login.getCode": "获取验证码",
  "5g.message.h5.login.input.phone": "请输入手机号",
  "5g.message.h5.login.phone.name": "手机号",

  "5g.message.h5.common.name.title": "5G消息助手",
  "5g.message.h5.common.name.chatbot": "机器人名称",
  "5g.message.h5.common.name.clear": "取消",
  "5g.message.h5.common.name.tem": "模板",
  "5g.message.h5.common.name.text": "文本",
  "5g.message.h5.common.name.addressSb": "地址上报",
  "5g.message.h5.common.name.img": "图片",
  "5g.message.h5.common.name.video": "视频",
  "5g.message.h5.common.name.audio": "音频",
  "5g.message.h5.common.name.file": "文件",
  "5g.message.h5.common.name.tip": "提示",
  "5g.message.h5.common.name.plsinput": "请输入内容！",
  "5g.message.h5.common.name.mycoll": "我的关注",
  "5g.message.h5.common.name.logout": "退出登录",
  "5g.message.h5.common.name.msg": "消息",
  "5g.message.h5.common.name.chatbot": "机器人",
  "5g.message.h5.common.name.my": "我的",

  "5g.message.h5.components.web": "网页",
  "5g.message.h5.components.chat": "聊天",
  "5g.message.h5.components.searchAddress": "搜索地址",
  "5g.message.h5.address.select": "请选择地址！",
  "5g.message.h5.tipmsg.msg1": "您的浏览器不支持 HTML5 video 标签",
  "5g.message.h5.tipmsg.msg2": "文件上传失败！发送失败！",
  "5g.message.h5.tipmsg.msg3": "查询服务号详情失败",
  "5g.message.h5.tipmsg.msg4": "设备信息上报成功！",
  "5g.message.h5.tipmsg.msg5": "请选择打开地图",
  "5g.message.h5.tipmsg.msg6": "暂不支持该功能！",
  "5g.message.h5.tipmsg.msg7": "您当前暂无聊天信息",
  "5g.message.h5.tipmsg.msg8": "快去机器人列表看看吧！",
  "5g.message.h5.tipmsg.msg9": "关注成功！",
  "5g.message.h5.tipmsg.msg10": "关注失败！",
  "5g.message.h5.tipmsg.msg11": "取消成功！",
  "5g.message.h5.tipmsg.msg12": "取消失败！"
};



// WEBPACK FOOTER //
// ./src/locales/zh_CN/all.js